import { render, staticRenderFns } from "./simplebar-scroll.vue?vue&type=template&id=cc7ac58e&scoped=true&"
import script from "./simplebar-scroll.vue?vue&type=script&lang=js&"
export * from "./simplebar-scroll.vue?vue&type=script&lang=js&"
import style0 from "./simplebar-scroll.vue?vue&type=style&index=0&id=cc7ac58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7ac58e",
  null
  
)

export default component.exports